import { apiClient } from './client'
import type { ProjectDetail } from './types'

/**
 * Phase 8 — Step Photo + Project Hero upload, update, delete. Server-proxied multipart uploads
 * (mirrors the Phase 7 Avatar pipeline). Each mutation returns the freshly hydrated
 * {@link ProjectDetail} so the caller can replace the project query payload directly.
 */

export const uploadStepPhoto = async (
  projectId: string,
  stepId: string,
  blob: Blob,
  caption?: string | null
): Promise<ProjectDetail> => {
  const form = new FormData()
  form.append('file', blob, 'photo.png')
  if (caption && caption.trim().length > 0) form.append('caption', caption.trim())
  const response = await apiClient.post<ProjectDetail>(
    `/api/v1/projects/${projectId}/steps/${stepId}/photos`,
    form,
    { headers: { 'Content-Type': 'multipart/form-data' } }
  )
  return response.data
}

export const updateStepPhoto = async (
  projectId: string,
  stepId: string,
  photoId: string,
  patch: { caption?: string | null; sortOrder?: number }
): Promise<ProjectDetail> => {
  const response = await apiClient.patch<ProjectDetail>(
    `/api/v1/projects/${projectId}/steps/${stepId}/photos/${photoId}`,
    patch
  )
  return response.data
}

export const deleteStepPhoto = async (
  projectId: string,
  stepId: string,
  photoId: string
): Promise<ProjectDetail> => {
  const response = await apiClient.delete<ProjectDetail>(
    `/api/v1/projects/${projectId}/steps/${stepId}/photos/${photoId}`
  )
  return response.data
}

export const uploadHero = async (projectId: string, blob: Blob): Promise<ProjectDetail> => {
  const form = new FormData()
  form.append('file', blob, 'hero.png')
  const response = await apiClient.post<ProjectDetail>(`/api/v1/projects/${projectId}/hero`, form, {
    headers: { 'Content-Type': 'multipart/form-data' },
  })
  return response.data
}

export const deleteHero = async (projectId: string): Promise<ProjectDetail> => {
  const response = await apiClient.delete<ProjectDetail>(`/api/v1/projects/${projectId}/hero`)
  return response.data
}
